import { render, staticRenderFns } from "./gc-record-field-template.vue?vue&type=template&id=04072b5a&scoped=true&"
import script from "./gc-record-field-template.vue?vue&type=script&lang=js&"
export * from "./gc-record-field-template.vue?vue&type=script&lang=js&"
import style0 from "./gc-record-field-template.vue?vue&type=style&index=0&id=04072b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04072b5a",
  null
  
)

export default component.exports